import OnPrem from './onPrem';

let sessionUtil;

export function initSessionUtil(isFromConsole, consoleUrl) {
  if (isFromConsole && consoleUrl) {
    return OnPrem;
  }

  return null;
}

export function getSessionUtil() {
  if (!sessionUtil) {
    return {};
  }

  const {refreshSessionOnInterval, clearRefreshSessionInterval} = sessionUtil;

  return {
    clearRefreshSessionInterval,
    refreshSessionOnInterval,
  };
}
